import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MadcapWebHelpPopupComponent} from '../madcap-web-help-popup/madcap-web-help-popup.component';
import {map, take, takeUntil} from 'rxjs/operators';
import { xml2json } from 'xml-js';

@Injectable({
  providedIn: 'root'
})
export class HelpService implements OnDestroy {
    // For local, we cannot use https://https://wfdssdev.firenet.gov/ because of CORS rules; So using Reggie's URL which is good for local test
    // For remote web app (dev/qa/uat/..), using relative path so it would append to root domain to create full URL
    private baseURL = (window.location.hostname === 'localhost') ? 'http://ptech-wfdss-doc-cms-demo.s3-website-us-east-1.amazonaws.com' : '/help' ;
    public madCapDataMap: { [key: string]: { Name: string; Link: string; Skin: string; ResolvedId: string } };
    private madCapDataSubs: Subscription;
    public _destroying = new Subject<void>();

    private sourceDomRect: DOMRect;

    private dialogWidth =  384;
    private dialogHeight = 457;

    constructor(private http: HttpClient, public dialog: MatDialog) {}

    showHelp(dataId: string, domRect: DOMRect): void {
        this.sourceDomRect = domRect;
        if (!this.madCapDataMap) {
            this.loadMadCapDataMap(dataId);
        } else {
            this.displayHelpPopup(dataId);
        }
    }

    private displayHelpPopup(dataId: string) {
        const dialogRef = this.dialog.open(MadcapWebHelpPopupComponent, {
            // width: '40%',
            width: this.dialogWidth + 'px',
            // height: '62%',
            height: this.dialogHeight + 'px',
            panelClass: 'help-dialog-container',
            position: this.getPosition(),
            data: { url: this.baseURL + '/Content/' + this.madCapDataMap[dataId].Link + '#cshid=' +
                    this.madCapDataMap[dataId].ResolvedId + '&Skin=' +
                    this.madCapDataMap[dataId].Skin }
        });

        // dialogRef.afterOpened().subscribe(() => {
        //     this.adjustPosition(dialogRef);
        // });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
        });
    }

    private adjustPosition(dialogRef: MatDialogRef<MadcapWebHelpPopupComponent, any>) {
        const popUpContainer = dialogRef.componentInstance.popUpContainer.nativeElement;
        const popUpDomRect = popUpContainer.getBoundingClientRect();

        let top = this.sourceDomRect.top + window.scrollY + 25; // Display it 25px below the source
        let left = this.sourceDomRect.left + window.scrollX;

        if (left + popUpDomRect.width > window.innerWidth) {
            left = window.innerWidth - popUpDomRect.width - 10; // 10px padding from the edge
        }

        if (top + popUpDomRect.height > window.innerHeight) {
            top = window.innerHeight - popUpDomRect.height - 10 - 25; // 10px padding from the edge; 25px above the source
        }

        dialogRef.updatePosition({ top: `${top}px`, left: `${left}px` });
    }

    private getPosition() {
        let top = this.sourceDomRect.top + window.scrollY + 25; // Display it 25px below the source
        let left = this.sourceDomRect.left + window.scrollX;

        if (left + this.dialogWidth > window.innerWidth) {
            left = window.innerWidth - this.dialogWidth - 10; // 10px padding from the edge
        }

        if (top + this.dialogHeight > window.innerHeight) {
            top = window.innerHeight - this.dialogHeight - 10 - 25; // 10px padding from the edge; 25px above the source
        }

        const position = { top: `${top}px`, left: `${left}px` };

        return position;
    }

    private loadMadCapDataMap(dataId: string) {
        this.getMadCapMapData().pipe(take(1)).subscribe(data => {
            this.madCapDataMap = data;
            this.displayHelpPopup(dataId);
        });
    }

    private getMadCapMapData() {
        const url = this.baseURL + `/Data/Alias.xml`;

        return this.http.get(url,
            {responseType: 'text'}).pipe(
            map((xml: string) => {
                const json = this.parseXml(xml);
                return this.transformJson(json);
            })
        );
    }

    parseXml(xmlData: string): any {
        const options = {
            compact: true,
            ignoreAttributes: false,
            ignoreDeclaration: true,
            ignoreDoctype: true,
            ignoreInstruction: true,
            ignoreComment: true,
            ignoreCdata: true
        };
        return JSON.parse(xml2json(xmlData, options));
    }


    private transformJson(json: any): { [key: string]: { Name: string; Link: string; Skin: string; ResolvedId: string } } {
        const transformed = {};
        json.CatapultAliasFile.Map.forEach((item: any) => {
            const dataMap = item._attributes;
            transformed[dataMap.ResolvedId] = dataMap;
        });
        return transformed;
    }

    ngOnDestroy() {
        this._destroying.next();
        this._destroying.complete();
    }
}
